import NewProduct from './NewProduct';

export default NewProduct;
